export const FieldProps = {
    Props:[
        { id: 'name', maxLength: 50, mandatory: true },
        { id: 'surname', maxLength: 50, mandatory: false },
        { id: 'address', maxLength: 80, mandatory: true },
        { id: 'houseno', maxLength: 10, mandatory: false },
        { id: 'country', maxLength: 50, mandatory: true },
        { id: 'city', maxLength: 50, mandatory: true },
        { id: 'province', maxLength: 2, mandatory: true },
        { id: 'zip', maxLength: 5, mandatory: true },
        { id: 'nation', maxLength: 50, mandatory: true },
        { id: 'at', maxLength: 80, mandatory: false },
        { id: 'email', maxLength: 70, mandatory: false },
        { id: 'phone', maxLength: 30, mandatory: false },
        { id: 'number', maxLength: 30, mandatory: false },
        { id: 'note', maxLength: 70, mandatory: false },
    ],

    getFieldProp: function (fieldName,fieldProp) {
        let prop = this.Props.find(a => a.id == fieldName.toLowerCase());
        if (prop == undefined) {
            return null;
        } 
        if (fieldProp in prop) {
            return prop[fieldProp];
        }
            
        return '';
    }

};
